import { render } from "./ApplicantsView.vue?vue&type=template&id=1f20c0c6"
import script from "./ApplicantsView.vue?vue&type=script&lang=js"
export * from "./ApplicantsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__